export default __webpack_public_path__ + "static/media/cotidiano-negative.b81b4ad5.svg";